import { render, staticRenderFns } from "./DiagonalStackedSquaresSVG.vue?vue&type=template&id=2c46506c"
import script from "./DiagonalStackedSquaresSVG.vue?vue&type=script&lang=ts"
export * from "./DiagonalStackedSquaresSVG.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports